import {useEffect, useState} from "react";
import {Box} from "@chakra-ui/react";
import {ChevronUpIcon} from "@chakra-ui/icons";

const ScrollToTopButton = ({menuOpen}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (menuOpen) return null;
  
  return (
    <Box position="fixed" bottom="3rem" right="3rem" zIndex="999">
      {isVisible && (
        <Box
          as="button"
          onClick={scrollToTop}
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="3.5rem"
          height="3.5rem"
          borderRadius="full"
          bg="blue.800"
          border="3px solid white"
          opacity={0.75}
          transition="all 0.2s ease-in-out"
          _hover={{transform: "scale(1.2)", bg:"blue.400", boxShadow: "0px 0px 10px rgba(6, 6, 89, 0.3)",}}
        >
          <ChevronUpIcon boxSize={8} color="white" />
        </Box>
      )}
    </Box>
  );
};

export default ScrollToTopButton;